export class Contact {
	latitude: number;
	longitude: number;
	address: string;
	phone: string;
	phone2: string;
	email2: string;
}
